import React from 'react';

import { useAuth } from 'contexts/auth';
import InstructorChat from 'pages/Chat/InstructorChat';
import StudentChat from 'pages/Chat/StudentChat';

const ChatPage = (props) => {
    const { auth } = useAuth();

    if (auth.role === 'instructor') return <InstructorChat {...props} />;
    if (auth.role === 'student') return <StudentChat {...props} />;
    return null;
};

export default ChatPage;
